import React from "react";
import {
  Check,
} from "./Icons";

export default function Feature({ name }) {
  return (
    <li className="flex items-center">
      <Check className="inline-block mr-2" />
      {name}
    </li>
  );
}
